// extracted by mini-css-extract-plugin
export var center = "_18-2";
export var clickableRow = "_18-5";
export var expandedRow = "_18-7";
export var hoverable = "_18-4";
export var left = "_18-1";
export var right = "_18-3";
export var row = "_18-0";
export var selectedRow = "_18-6";
export var summaryRow = "_18-8";